import React, { Component } from "react";
import {
  Popover,
  PopoverBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "../libraries/reactstrap";

import { RequoteConsumer } from "../context/quote-versioning-context";
import headerImg from "../images/policy.svg";
import crossImg from "../images/xs.svg";

import PolicyQuoteCard from "./PolicyQuoteCard";
import PolicyQuoteCard2 from "./PolicyQuoteCard/PolicyQuoteCard2";

class PoliciesPanel extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.sortToggle = this.sortToggle.bind(this);
    this.filter = this.filter.bind(this);
    this.viewCard = this.viewCard.bind(this);

    this.state = {
      popoverOpen: false,
      sortOpen: false,
      filter: {
        // ivantage: true,
        // insureon: true,
        // abi: true,
        policies: true,
        quotes: true,
        gl: true,
        bop: true,
        eo: true,
        wc: true,
        home: true,
        auto: true,
        other: true,
      },
    };
    this.bubbles = [];
  }

  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen,
    });
  }

  sortToggle() {
    this.setState((prevState) => ({
      sortOpen: !prevState.sortOpen,
    }));
  }

  toggleFiler(newFilter) {
    var result = Object.assign(this.state.filter, newFilter);

    this.setState({ filter: result });
  }

  isItemVisible(isPersonal, item) {
    if (isPersonal) {
      if (
        (this.state.filter.home && item.LobCode === "PHO") ||
        (this.state.filter.auto && item.LobCode === "PAF") ||
        (this.state.filter.other &&
          item.LobCode !== "PHO" &&
          item.LobCode !== "PAF")
      ) {
        return true;
      }

      return false;
    } else {
      if (
        (this.state.filter.gl &&
          (item.LobCode === "GL" || item.LobCode === "CGP")) ||
        (this.state.filter.bop &&
          (item.LobCode === "BOP" || item.LobCode === "CBP")) ||
        (this.state.filter.eo &&
          (item.LobCode === "EO" ||
            item.LobCode === "CGP" ||
            item.LobCode === "CBP")) ||
        (this.state.filter.wc && item.LobCode === "WC") ||
        (this.state.filter.other &&
          item.LobCode !== "WC" &&
          item.LobCode !== "EO" &&
          item.LobCode !== "BOP" &&
          item.LobCode !== "GL")
      ) {
        return true;
      }

      return false;
    }
  }

  filter(elements, isPersonal, item) {
    const viewed = !this.bubbles.find((b) => item.PolicyQuoteId === b);

    if (
      this.state.filter.gl || this.state.filter.bop || this.state.filter.eo || this.state.filter.wc
      || this.state.filter.home || this.state.filter.auto || this.state.filter.other
    ) {
      elements.push(
        <PolicyQuoteCard2
          key={item.PolicyQuoteId + "_"}
          data={item}
          alreadyViewed={viewed}
          selectedPolicyQuoteId={this.props.selectedPolicyQuoteId}
          viewCallback={this.viewCard}
          hideLobDetails={this.props.hideLobDetails}
          onReload={this.props.reload}
        />,
        // <PolicyQuoteCard
        //   key={item.PolicyQuoteId}
        //   data={item}
        //   viewCallback={this.viewCard}
        //   alreadyViewed={viewed}
        //   viewNotesCallback={this.props.viewNotesCallback}
        //   hideLobDetails={this.props.hideLobDetails}
        //   selectedPolicyQuoteId={this.props.selectedPolicyQuoteId}
        //   showCarrierMessages={this.props.showCarrierMessages}
        //   reload={this.props.reload}
        // />
      );
    }
  }

  viewCard(info) {
    if (this.bubbles.find((id) => info.policyQuoteId === id)) {
      this.bubbles.splice(this.bubbles.indexOf(info.policyQuoteId), 1);
    }

    this.props.viewCallback(info);
  }

  componentDidMount() {
    if (this.props.ready) {
      this.props.loadClientNotifications(this.props.clientId);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let clientId = this.props.clientId;

    if (
      this.props.ready &&
      (!prevProps.ready || prevProps.clientId !== clientId)
    ) {
      this.props.loadClientNotifications(clientId);
    }

    if (this.props.data !== prevProps.data) {
      let newFilter = {};

      if (this.props.data.AdditionalData.IsPersonalClient) {
        newFilter.gl = false;
        newFilter.bop = false;
        newFilter.eo = false;
        newFilter.wc = false;
      } else {
        newFilter.auto = false;
        newFilter.home = false;
      }

      this.toggleFiler(newFilter);
    }
  }

  popupBubbles(elements) {
    let bubbles = elements.filter((c) => !!!c.props.data.Ready);

    if (bubbles.length > 0) {
      for (let i = 0; i < bubbles.length; i++) {
        elements.splice(
          0,
          0,
          elements.splice(elements.indexOf(bubbles[i]), 1)[0]
        );
      }
    }
  }

  render() {
    return (
      <RequoteConsumer>
        {(context) => {
          if (context.newCards.some((c) => !this.bubbles.includes(c))) {
            this.bubbles = context.newCards;
          }
          let elements = [];
          let isPersonal = false;
          let cardsNumber = 0;
          if (this.props.data) {
            if (this.props.data.AdditionalData.IsPersonalClient) {
              isPersonal = true;
            }
            cardsNumber = this.props.data.Cards.length;
            for (let i = 0; i < this.props.data.Cards.length; i++) {
              let item = this.props.data.Cards[i].Data;
              if (
                (this.state.filter.policies && this.state.filter.quotes) ||
                (this.state.filter.policies && item.IsPolicy) ||
                (this.state.filter.quotes && !item.IsPolicy)
              ) {
                this.filter(elements, isPersonal, item);
              }
            }
          }

          this.popupBubbles(elements);

          const newBubbles = elements
            .filter((e) => !!!e.props.data.Ready)
            .map((b) => b.props.data.PolicyQuoteId)
            .filter((b) => !this.bubbles.includes(b));

          if (newBubbles.length > 0) {
            context.addNewCards(newBubbles);
          }

          return (
            <div className="four-panel">
              <div className="four-panel-main-header">
                <img alt="policies" src={headerImg} />{" "}
                <span className="four-panel-main-header-name">
                  POLICIES/QUOTES
                </span>
              </div>
              <div
                className="four-panel-small"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "#fff",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  height: "44px",
                }}
              >
                <Dropdown
                  isOpen={this.state.sortOpen}
                  toggle={this.sortToggle}
                  className="policies-sort-main"
                >
                  <DropdownToggle caret className="policies-sort">
                    Sort
                    <div className="sort-down" />
                  </DropdownToggle>
                  <DropdownMenu className="policies-sort-items">
                    <DropdownItem
                      className="policies-sort-item"
                      onClick={(e) => this.props.sortCards("asc", "Id")}
                    >
                      Quote # Ascending
                    </DropdownItem>
                    <DropdownItem
                      className="policies-sort-item"
                      onClick={(e) => this.props.sortCards("desc", "Id")}
                    >
                      Quote # Descending
                    </DropdownItem>
                    <DropdownItem
                      className="policies-sort-item"
                      onClick={(e) => this.props.sortCards("asc", "Lob")}
                    >
                      LOB A-Z
                    </DropdownItem>
                    <DropdownItem
                      className="policies-sort-item"
                      onClick={(e) => this.props.sortCards("desc", "Lob")}
                    >
                      LOB Z-A
                    </DropdownItem>
                    <DropdownItem
                      className="policies-sort-item"
                      onClick={(e) => this.props.sortCards("asc", "Carrier")}
                    >
                      Carrier A-Z
                    </DropdownItem>
                    <DropdownItem
                      className="policies-sort-item"
                      onClick={(e) => this.props.sortCards("desc", "Carrier")}
                    >
                      Carrier Z-A
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <div>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <button
                    onClick={this.toggle}
                    className="four-panel-main-header-filter filter-policies"
                  >
                    <span id="policies-filter">Filter </span>
                    <div className="sort-down" />
                  </button>
                  <Popover
                    placement="bottom"
                    trigger="legacy"
                    fade={false}
                    isOpen={this.state.popoverOpen}
                    target="policies-filter"
                    toggle={this.toggle}
                    offset={"[-77, 0]"}
                  >
                    <PopoverBody className="filter-body">
                      <div className="header-block">
                        Filter by:
                        {this.state.filter.policies || this.state.filter.quotes ? (
                          // eslint-disable-next-line jsx-a11y/anchor-is-valid
                          <a
                            onClick={(e) => {
                              this.toggleFiler({
                                policies: false,
                                quotes: false,
                              });
                            }}
                          >
                            Deselect all
                          </a>
                        ) : (
                          // eslint-disable-next-line jsx-a11y/anchor-is-valid
                          <a
                            onClick={(e) => {
                              this.toggleFiler({
                                policies: true,
                                quotes: true,
                              });
                            }}
                          >
                            Select all
                          </a>
                        )}
                      </div>

                      <div>
                        Policies{" "}
                        <input
                          onChange={(e) => {
                            this.toggleFiler({ policies: e.target.checked });
                          }}
                          type="checkbox"
                          checked={this.state.filter.policies}
                        />
                      </div>
                      <div>
                        Quotes{" "}
                        <input
                          onChange={(e) => {
                            this.toggleFiler({ quotes: e.target.checked });
                          }}
                          type="checkbox"
                          checked={this.state.filter.quotes}
                        />
                      </div>
                      <div className="header-block">
                        LOB
                        {this.state.filter.gl || this.state.filter.bop || this.state.filter.eo || this.state.filter.wc
                          || this.state.filter.other ? (
                          // eslint-disable-next-line jsx-a11y/anchor-is-valid
                          <a
                            onClick={(e) => {
                              this.toggleFiler({
                                gl: false,
                                bop: false,
                                eo: false,
                                wc: false,
                                other: false,
                                home: false,
                                auto: false,
                              });
                            }}
                          >
                            Deselect all
                          </a>
                        ) : (
                          // eslint-disable-next-line jsx-a11y/anchor-is-valid
                          <a
                            onClick={(e) => {
                              this.toggleFiler({
                                gl: true,
                                bop: true,
                                eo: true,
                                wc: true,
                                other: true,
                                home: true,
                                auto: true,
                              });
                            }}
                          >
                            Select all
                          </a>
                        )}
                      </div>
                      {!isPersonal && (
                        <div>
                          GL{" "}
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              this.toggleFiler({ gl: e.target.checked });
                            }}
                            checked={this.state.filter.gl}
                          />
                        </div>
                      )}
                      {!isPersonal && (
                        <div>
                          BOP{" "}
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              this.toggleFiler({ bop: e.target.checked });
                            }}
                            checked={this.state.filter.bop}
                          />
                        </div>
                      )}
                      {!isPersonal && (
                        <div>
                          E&O{" "}
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              this.toggleFiler({ eo: e.target.checked });
                            }}
                            checked={this.state.filter.eo}
                          />
                        </div>
                      )}
                      {!isPersonal && (
                        <div>
                          WC{" "}
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              this.toggleFiler({ wc: e.target.checked });
                            }}
                            checked={this.state.filter.wc}
                          />
                        </div>
                      )}
                      {isPersonal && (
                        <div>
                          HOME{" "}
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              this.toggleFiler({ home: e.target.checked });
                            }}
                            checked={this.state.filter.home}
                          />
                        </div>
                      )}
                      {isPersonal && (
                        <div>
                          AUTO{" "}
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              this.toggleFiler({ auto: e.target.checked });
                            }}
                            checked={this.state.filter.auto}
                          />
                        </div>
                      )}
                      <div>
                        Other{" "}
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            this.toggleFiler({ other: e.target.checked });
                          }}
                          checked={this.state.filter.other}
                        />
                      </div>
                    </PopoverBody>
                  </Popover>
                </div>
              </div>
              <div className="policies-filter-bubbles">
                {this.state.filter.policies && (
                  <div className="filter-bubble-item">
                    Policies{" "}
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      onClick={(e) => {
                        this.toggleFiler({ policies: false });
                      }}
                    >
                      <img alt="" src={crossImg} />
                    </a>
                  </div>
                )}
                {this.state.filter.quotes && (
                  <div className="filter-bubble-item">
                    Quotes{" "}
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      onClick={(e) => {
                        this.toggleFiler({ quotes: false });
                      }}
                    >
                      <img alt="" src={crossImg} />
                    </a>
                  </div>
                )}

                {!isPersonal && this.state.filter.gl && (
                  <div className="filter-bubble-item">
                    GL {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      onClick={(e) => {
                        this.toggleFiler({ gl: false });
                      }}
                    >
                      <img alt="" src={crossImg} />
                    </a>
                  </div>
                )}
                {!isPersonal && this.state.filter.bop && (
                  <div className="filter-bubble-item">
                    BOP{" "}
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      onClick={(e) => {
                        this.toggleFiler({ bop: false });
                      }}
                    >
                      <img alt="" src={crossImg} />
                    </a>
                  </div>
                )}
                {!isPersonal && this.state.filter.eo && (
                  <div className="filter-bubble-item">
                    E&O{" "}
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      onClick={(e) => {
                        this.toggleFiler({ eo: false });
                      }}
                    >
                      <img alt="" src={crossImg} />
                    </a>
                  </div>
                )}
                {!isPersonal && this.state.filter.wc && (
                  <div className="filter-bubble-item">
                    WC {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      onClick={(e) => {
                        this.toggleFiler({ wc: false });
                      }}
                    >
                      <img alt="" src={crossImg} />
                    </a>
                  </div>
                )}
                {isPersonal && this.state.filter.home && (
                  <div className="filter-bubble-item">
                    HOME{" "}
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      onClick={(e) => {
                        this.toggleFiler({ home: false });
                      }}
                    >
                      <img alt="" src={crossImg} />
                    </a>
                  </div>
                )}
                {isPersonal && this.state.filter.auto && (
                  <div className="filter-bubble-item">
                    AUTO{" "}
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      onClick={(e) => {
                        this.toggleFiler({ auto: false });
                      }}
                    >
                      <img alt="" src={crossImg} />
                    </a>
                  </div>
                )}
                {this.state.filter.other && (
                  <div className="filter-bubble-item">
                    Other{" "}
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      onClick={(e) => {
                        this.toggleFiler({ other: false });
                      }}
                    >
                      <img alt="" src={crossImg} />
                    </a>
                  </div>
                )}
              </div>
              <div className="pq-panels">
                {elements.length > 0 ? (
                  elements
                ) : cardsNumber > 0 ? (
                  ""
                ) : (
                  <div className={"pq-card"}>
                    <span>We're working on this request.</span>
                  </div>
                )}
              </div>
            </div>
          );
        }}
      </RequoteConsumer>
    );
  }
}

export default PoliciesPanel;
